(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hn-home-stories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hn-home-stories')) {
    customElements.define('hn-home-stories', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.track = this.querySelector('[data-stories-track]');
        if (!this.track) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.videos = [...this.querySelectorAll('video')];
        this.previousButton = this.querySelector('[data-stories-previous]');
        this.nextButton = this.querySelector('[data-stories-next]');
        this.navigation = this.querySelector('[data-stories-navigation]');

        const updateNavigation = () => {
          const position = Math.abs(this.track.scrollLeft);
          const maximum = this.track.scrollWidth - this.track.clientWidth;
          this.navigation.hidden = maximum <= 2;
          this.previousButton.disabled = position <= 2;
          this.nextButton.disabled = position >= maximum - 2;
        };

        const move = (direction) => {
          const card = this.track.firstElementChild;
          if (!card) return;
          const styles = getComputedStyle(this.track);
          const step = card.getBoundingClientRect().width + (parseFloat(styles.columnGap) || 0);
          const multiplier = styles.direction === 'rtl' ? -1 : 1;
          this.track.scrollBy({
            left: step * direction * multiplier,
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
          });
        };

        this.previousButton.addEventListener('click', () => move(-1), { signal });
        this.nextButton.addEventListener('click', () => move(1), { signal });
        this.track.addEventListener('scroll', updateNavigation, { passive: true, signal });

        this.videos.forEach((video) => {
          const playButton = video.parentElement.querySelector('[data-stories-play]');
          if (!playButton) return;
          const updatePlayButton = () => {
            playButton.hidden = !video.paused && !video.ended;
          };
          playButton.addEventListener('click', async () => {
            playButton.disabled = true;
            try {
              await video.play();
              updatePlayButton();
            } catch {
              playButton.hidden = false;
            } finally {
              playButton.disabled = false;
            }
          }, { signal });
          video.addEventListener('play', updatePlayButton, { signal });
          video.addEventListener('pause', updatePlayButton, { signal });
          video.addEventListener('ended', updatePlayButton, { signal });
          updatePlayButton();
        });

        document.addEventListener('play', (event) => {
          this.videos.forEach((video) => {
            if (video !== event.target) video.pause();
          });
        }, { capture: true, signal });

        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.videos.forEach((video) => video.pause());
        }, { signal });

        this.visibilityObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.intersectionRatio < 0.35) entry.target.pause();
          });
        }, { threshold: [0, 0.35] });
        this.videos.forEach((video) => this.visibilityObserver.observe(video));
        this.resizeObserver = new ResizeObserver(updateNavigation);
        this.resizeObserver.observe(this.track);
        updateNavigation();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.visibilityObserver?.disconnect();
        this.resizeObserver?.disconnect();
        this.videos?.forEach((video) => video.pause());
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
